import store from '../../store'
export function moveimg2(id) {
	var xPos = 0;
	var yPos = 0;
	var step = 1;
	var delay = 25;
	var height = 0;
	var Hoffset = 0;
	var Woffset = 0;
	var yon = 0;
	var xon = 0;
	var pause = true;
	var interval;
	var width;
	var height;
	id.style.top = yPos + 'px';
	var changePos = function () {
		if (typeof store.state.moveTwo != 'undefined' && store.state.moveTwo) {

		} else {
			width = document.body.clientWidth;
			height = document.body.clientHeight;
			Hoffset = id.offsetHeight;
			Woffset = id.offsetWidth;
			id.style.right = (Number(xPos + document.body.scrollLeft) + Number(width)) / 2 + 'px';
			id.style.top = (yPos + document.body.scrollTop) + 'px';
			if (yon) { yPos = yPos + step; }
			else { yPos = yPos - step; }
			if (yPos < 0) { yon = 1; yPos = 0; }
			if (yPos >= (height - Hoffset)) { yon = 0; yPos = (height - Hoffset); }
			if (xon) { xPos = xPos + step; }
			else { xPos = xPos - step; }
			if (xPos < 0) { xon = 1; xPos = 0; }
			if (xPos >= (width - Woffset)) { xon = 0; xPos = (width - Woffset); }
		}
	}

	function start() {
		id.visibility = "visible";
		interval = setInterval(changePos, delay);
	}
	function pause_resume() {
		if (pause) {
			clearInterval(interval);
			pause = false;
		}
		else {
			interval = setInterval(changePos, delay);
			pause = true;
		}
	}
	start();
}